import { render, staticRenderFns } from "./FPageNewPassword.vue?vue&type=template&id=66cf1ae0&scoped=true&"
import script from "./FPageNewPassword.vue?vue&type=script&lang=js&"
export * from "./FPageNewPassword.vue?vue&type=script&lang=js&"
import style0 from "./FPageNewPassword.vue?vue&type=style&index=0&id=66cf1ae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cf1ae0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/souzaramon/repos/personal/fluid/pwa-fluid/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VTextField,VToolbar,VToolbarTitle})
